const inputs = {
    name: {
        id: 'name',
        name: 'name',
        input: 'textField',
        label: 'companyList.form.name.label',
        placeholder: 'companyList.form.name.placeholder',
        rules: {
        required: { value: true },
      },
    },
  description: {
      id: 'description',
      name: 'description',
      input: 'textField',
      label: 'companyList.form.description.label',
  },
}

export default inputs;
